import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.catalog || initialState;

export const selectCatalog = createSelector([selectSlice], state => state);

export const selectIsLoading = createSelector(
  [selectCatalog],
  state => state.loading,
);

export const selectIsError = createSelector(
  [selectCatalog],
  state => state.error,
);

export const selectIsSuccess = createSelector(
  [selectCatalog],
  state => state.success,
);

/**
 * NOTE: SHOW
 */

export const selectOptionsGetShows = createSelector(
  [selectCatalog],
  state => state.optionsGetShows,
);

export const selectListFilterShowDynamic = createSelector(
  [selectCatalog],
  state => state.listFilterShowDynamic,
);

export const selectListShow = createSelector(
  [selectCatalog],
  state => state.listShow,
);

export const selectDetailShow = createSelector(
  [selectCatalog],
  state => state.detailShow,
);

/**
 * NOTE: TICKET
 */

export const selectOptionsGetTickets = createSelector(
  [selectCatalog],
  state => state.optionsGetTickets,
);

export const selectListFilterTicketDynamic = createSelector(
  [selectCatalog],
  state => state.listFilterTicketDynamic,
);

export const selectListTicket = createSelector(
  [selectCatalog],
  state => state.listTicket,
);
/**
 * NOTE: CATALOG
 */
export const selectListCatalog = createSelector(
  [selectCatalog],
  state => state.listCatalog,
);
export const selectListNew = createSelector(
  [selectCatalog],
  state => state.listNew,
);
export const selectListPromotionPark = createSelector(
  [selectCatalog],
  state => state.listPromotionPark,
);
export const selectListPromotion = createSelector(
  [selectCatalog],
  state => state.listPromotion,
);
export const selectPaginatorPromotionPark = createSelector(
  [selectCatalog],
  state => state.paginatorPromotionPark,
);
export const selectPaginator = createSelector(
  [selectCatalog],
  state => state.paginator,
);
export const selectGetListShow = createSelector(
  [selectCatalog],
  state => state.getListShowSuccess,
);
export const selectNotFound = createSelector(
  [selectCatalog],
  state => state.errorNotFound,
);
export const selectGetListPaymentMethods = createSelector(
  [selectCatalog],
  state => state.listPaymentMethod,
);
export const selectIsLoadingPaymentMethod = createSelector(
  [selectCatalog],
  state => state.loadingPaymentMethod,
);
export const selectGetListTicketForms = createSelector(
  [selectCatalog],
  state => state.listTicketForm,
);
